import { useCallback, useEffect, useRef, useState } from "react";
import { createId } from "../utils/formatters";

export default function useNotifications() {
  const [notifications, setNotifications] = useState([]);
  const timersRef = useRef(new Map());

  const closeNotification = useCallback((id) => {
    const timer = timersRef.current.get(id);

    if (timer) {
      window.clearTimeout(timer);
      timersRef.current.delete(id);
    }

    setNotifications((items) => items.filter((item) => item.id !== id));
  }, []);

  const showNotification = useCallback(
    (type, message, options = {}) => {
      const id = createId();
      const duration = options.duration ?? 3600;

      setNotifications((items) => [
        ...items,
        {
          id,
          type,
          message,
          actionLabel: options.actionLabel,
          onAction: options.onAction
        }
      ]);

      if (duration > 0) {
        const timer = window.setTimeout(() => closeNotification(id), duration);
        timersRef.current.set(id, timer);
      }

      return id;
    },
    [closeNotification]
  );

  useEffect(
    () => () => {
      timersRef.current.forEach((timer) => window.clearTimeout(timer));
      timersRef.current.clear();
    },
    []
  );

  return {
    closeNotification,
    notifications,
    showNotification
  };
}
